(function() {
    
    const queryString = window.location.search;
    const urlParameters = new URLSearchParams(queryString);
    const clientApiKey = 'jkngf8u9743ntdRAHfgsu980t56u8';
    const billingEmail = urlParameters.get('email')
    const orderID = urlParameters.get('orderNumber')

    if( orderID && billingEmail ) {
        $('#trackorder_button').addClass('disabled');
        redirectOrderPageURL( clientApiKey, billingEmail, orderID )      
    }

    $('body').on('click', '#trackorder_button', function(e) {
        $('#trackorder_button').addClass('disabled');

        const orderID = $('#order_id').val();
        const billingEmail = $('#billingEmail').val();

        if( !orderID || !billingEmail ) {
            alert('Please complete the needed fields');
        } else {
            redirectOrderPageURL( clientApiKey, billingEmail, orderID )      
        }
    })

    function redirectOrderPageURL ( clientApiKey, email, orderNumber) {
        fetch(`https://app-lj-shipping-charges.azurewebsites.net/SalesOrder/TrackMyOrder?clientApiKey=${clientApiKey}&email=${encodeURIComponent(email)}&orderNumber=${encodeURIComponent(orderNumber)}`)
            .then(res => res.json())
            .then(data => {
                $('#trackorder_button').removeClass('disabled');
                window.location.href = data.orderStatusUrl
            })
            .catch(err => {
                $('#trackorder_button').removeClass('disabled');
                $('#form_container').hide();
                $('#alert_container').show();
            });
    }
})(jQuery)